import ApiClient from "../helpers/ApiClient";
import useSWR from "swr";

const fetcher = (url) => ApiClient.get(url).then((res) => res.data);

// Shifts SWR Hook
export function useShifts() {
  const APIURL = "/hr/shifts";
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    mutate,
  };
}

// Shifts Operations
export async function addNewShift(name, startTime, endTime) {
  try {
    const response = await ApiClient.post("/hr/shifts/add", {
      name,
      start_time: startTime,
      end_time: endTime,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to add shift";
  }
}

export async function deleteShift(id) {
  try {
    const response = await ApiClient.delete(`/hr/shifts/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to delete shift";
  }
}

// Shift Logs SWR Hook
export function useShiftLogs(startDate, endDate) {
  const APIURL = startDate && endDate ? `/hr/shift-logs?startDate=${startDate}&endDate=${endDate}` : null;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    mutate,
  };
}

// Shift Logs Operations
export async function addNewShiftLog(username, shiftId, date) {
  try {
    const response = await ApiClient.post("/hr/shift-logs/add", {
      username,
      shift_id: shiftId,
      date,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to log shift";
  }
}

export async function deleteShiftLog(id) {
  try {
    const response = await ApiClient.delete(`/hr/shift-logs/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to delete shift log";
  }
}

// Transactions (Incentives and Fines) SWR Hook
export function useStaffTransactions(startDate, endDate) {
  const APIURL = startDate && endDate ? `/hr/transactions?startDate=${startDate}&endDate=${endDate}` : null;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    mutate,
  };
}

// Transactions Operations
export async function addNewStaffTransaction(username, type, amount, reason, date) {
  try {
    const response = await ApiClient.post("/hr/transactions/add", {
      username,
      type,
      amount: parseFloat(amount),
      reason,
      date,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to record transaction";
  }
}

export async function deleteStaffTransaction(id) {
  try {
    const response = await ApiClient.delete(`/hr/transactions/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to delete transaction";
  }
}

// Staff Payroll Details Hook
export function useStaffPayrollDetails(startDate, endDate) {
  const APIURL = startDate && endDate ? `/hr/payroll-details?startDate=${startDate}&endDate=${endDate}` : null;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    mutate,
  };
}
